import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ExternalBuyerMappingsActions = createActionGroup({
  source: 'External Buyer Mappings',
  events: {
    'Upload Mappings': props<{
      file: File;
      buyerId: string;
      buyerKey: string;
    }>(),
    'Upload Mappings Success': props<{ count: number }>(),
    'Upload Mappings Failure': props<{ error: string }>(),
    'Upload Mappings Reset': emptyProps(),

    'Download Mappings': props<{ buyerId: string; fileName: string }>(),
    'Download Mappings Success': emptyProps(),
    'Download Mappings Failure': props<{ error: string }>(),
    'Download Mappings Reset': emptyProps(),
  },
});
